module.exports = __webpack_public_path__ + "static/img/volume-have.9b79f5dc.svg";